import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Activity } from "lucide-react";

export default function ProtectedRoute() {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#F8FAFC]">
        <Activity className="h-8 w-8 animate-pulse text-[#18A6A6]" />
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (user.role === "admin" && location.pathname === "/onboarding") {
    return <Navigate to="/admin" replace />;
  }
  const onboarded = user?.profile?.onboarded;
  if (user.role !== "admin" && !onboarded && location.pathname !== "/onboarding") {
    return <Navigate to="/onboarding" replace />;
  }
  return <Outlet />;
}
